import React from 'react';
import PropTypes from 'prop-types';
import events from '../../../lib/events.js';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';

const intOrString = val => {
  let integral = parseInt(val);
  let newVal = isNaN(integral) || integral.toString().length !== val.length ? val : integral;

  return newVal;
};

class EditableSelectField extends React.PureComponent {
  static displayName = 'EditableSelectField';

  static propTypes = {
    dataKey: PropTypes.string,
    editMode: PropTypes.bool.isRequired,
    keys: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    optionsChange: PropTypes.bool,
    validate: PropTypes.func,
    validateMessage: PropTypes.string,
    value: PropTypes.any,
    'data-event-action': PropTypes.string,
    'data-event-category': PropTypes.string,
    group: PropTypes.object,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    optionsChange: false,
  };

  state = {
    correct: true,
    highlighted: false,
    validate: null,
  };

  componentWillMount() {
    if (this.props.dataKey) {
      let listener = events.subscribe('focus|' + this.props.dataKey, () => {
        this.focus();
      });

      this.listener = listener;
    }
  }

  componentDidMount() {
    if (this.props.group) { // Even though not keybinding put in did mount so doesn't render faster than other components and get list in wrong order
      this.props.group.addComponent(this, false);
    }
  }

  componentWillReceiveProps(nextProps) {
    // Validate when props change
    if (this.state.validate && this.props.options.length > 0) {
      this.state.validate(nextProps.value);
    }

    if (this.props.optionsChange && nextProps.optionsChange && !isEqual(nextProps.options, this.props.options) &&
      !(nextProps.keys ? nextProps.keys.includes(this.props.value) : nextProps.options.includes(this.props.value))) {
      let val = nextProps.value;

      if (nextProps.keys && nextProps.keys.length > 0 && nextProps.keys.indexOf(nextProps.value) === -1) {
        val = nextProps.keys[0];
      } else if (nextProps.options && nextProps.options.length > 0 && nextProps.options.indexOf(nextProps.value) === -1) {
        val = nextProps.options[0];
      } else if (nextProps.options && nextProps.options.length === 0) {
        val = null;
      }

      if (this.props.onChange && this.props.dataKey) {
        this.props.onChange({key: this.props.dataKey, value: intOrString(val)});
      }
    }

    if (this.state.highlighted && nextProps.editMode !== this.props.editMode) {
      this.setState({
        highlighted: false,
      });
    }
  }

  componentWillUnmount() {
    if (this.props.group) {
      this.props.group.removeComponent(this, false);
    }

    if (this.listener) {
      this.listener.remove();
    }
  }

  listener = null;

  validate = (val = this.props.value) => {
    if (this.props.required && !val && val !== 0) {
      this.setState({
        correct: false,
      });
      return false;
    }

    if (!this.state.correct && this.props.required && (val || val === 0) && (!this.props.value || this.props.value === 0)) {
      this.setState({
        correct: true,
      });
      return true;
    }

    if (!this.props.validate) {
      this.setState({
        correct: true,
      });
      return true;
    }

    let validateResult = this.props.validate(val);

    if (validateResult === false) {
      this.setState({
        correct: false,
      });

      if (val && this.props.validateMessage) {
        events.publish('error.user', {
          message: this.props.validateMessage,
          key: this.props.dataKey,
        });
      }
      return false;
    }

    this.setState({correct: true});
    events.publish('cancel.error', {key: this.props.dataKey});
    return true;
  };

  focus = () => {
    if (this.refs.underlying) {
      this.refs.underlying.focus();
      this.refs.underlying.scrollIntoView(false);
    }
  };

  highlight = () => {
    this.setState({
      highlighted: true,
    });
  };

  handleChange = (e) => {
    if (this.props.onChange) {
      let val = parseInt(e.target.value);

      val = isNaN(val) || val.toString().length !== e.target.value.length ? e.target.value : val;
      this.props.onChange({key: this.props.dataKey, value: val});

      if (!this.state.correct) {
        this.validate(val);
      }
    }
  };

  focusHandler = () => {
    if (this.state.highlighted) {
      this.setState({highlighted: false});
    }
  };

  render() {
    let content;

    if (this.props.editMode) {

      let optionsList = [];

      for (let i = 0; i < this.props.options.length; ++i) {
        let item = this.props.options[i];
        let key = this.props.options[i];

        if (this.props.keys && this.props.keys.length > 0) {
          key = this.props.keys[i];
        }
        optionsList.push(<option key={i} value={key}>{item}</option>);
      }

      content =
        <select value={this.props.value}
                // Set events on all interactions with select field so that if user skips the field it shows message
                className={classNames('form-control', {'error': !this.state.correct, 'form-control--highlighted': this.state.highlighted})}
                onChange={this.handleChange}
                ref='underlying'
                disabled={this.props.disabled}
                onFocus={this.focusHandler}
                data-event-category={this.props['data-event-category']} data-event-action={this.props['data-event-action']} >
          {optionsList}
        </select>
      ;
    } else {
      let displayText;

      if (this.props.keys && this.props.keys.length > 0) {
        displayText = this.props.options[this.props.keys.indexOf(this.props.value)];
      } else {
        displayText = this.props.value;
      }

      content = <div className='form-control-static'>{displayText}</div>;
    }

    return (
      <div className='editable-selectfield'>{content}</div>
    );
  }
}

export default EditableSelectField;
